import { put, call, takeLatest } from 'redux-saga/effects'
import {
    dCategoriesAddItemSagaAC,
    dCategoriesBulkDeleteSagaAC,
    dCategoriesDeleteItemSagaAC,
    dCategoriesEditItemSagaAC, dCategoriesRecoverBulkSagaAC,
    dCategoriesSetDataAC, dCategoriesSetDataSagaAC,
    dCategoriesSetPaginationAC
} from './dCategoriesActionCreators'
import { dashboardLoaderAC } from '../system/systemActionCreators'
import {
    bulkRecoverCategory,
    deleteCategoriesBulk,
    getCategoriesList
} from './dCategoriesAPI'
import { IdCategoriesStateDataItem, typeCategoriesFilters } from './dCategoriesReducer'
import {
    paginationMapper,
    typePagination,
    typeRequestPagination
} from '../system/constants';
import { errorGenerator, notificationCreator } from 'model/system/utils';


// Temp data list mapper
const tempDataMapper = (tempResponseData: any): IdCategoriesStateDataItem[] => {
    return tempResponseData.map((item: IdCategoriesStateDataItem) => {
        return (
            {
                checked: false,
                id: item.id,
                name: item.name,
                active: item.active,
                deleted: item.deleted
            }
        )
    })
}

// Get data function-generator
function* getData(payload: { filters: typeCategoriesFilters, paginationRequest: typeRequestPagination }) {

    let response = yield call(getCategoriesList, payload)

    if (response.status === 200) {

        const tempData: IdCategoriesStateDataItem[] = tempDataMapper(response.data.content)
        const pagination: typePagination = paginationMapper(response.data)

        yield put(dCategoriesSetPaginationAC(pagination))
        yield put(dCategoriesSetDataAC(tempData))

    } else {
        yield errorGenerator(response)
    }
}


// ---------------------------------------------------------------------------------------------------------------------
// Saga set categories
export function* dCategoriesSetDataWorker(actionObject: {
    type: string,
    payload: { filters: typeCategoriesFilters, paginationRequest: typeRequestPagination }
}) {

    yield put(dashboardLoaderAC(true))
    yield getData(actionObject.payload)
    yield put(dashboardLoaderAC(false))

}

export function* dCategoriesSetDataWatcher() {
    yield takeLatest(dCategoriesSetDataSagaAC.type, dCategoriesSetDataWorker)
}


// ---------------------------------------------------------------------------------------------------------------------
// Saga edit data item
export function* dCategoriesEditItemWorker(actionObject: {
    type: string,
    payload: {
        filters: typeCategoriesFilters,
        paginationRequest: typeRequestPagination
    }
}) {

    yield put(dashboardLoaderAC(true))

    yield notificationCreator('SUCCESS_CHANGE_ITEM')
    yield getData({
                      filters: actionObject.payload.filters,
                      paginationRequest: actionObject.payload.paginationRequest
                  })

    yield put(dashboardLoaderAC(false))

}

export function* dCategoriesEditDataWatcher() {
    yield takeLatest(dCategoriesEditItemSagaAC.type, dCategoriesEditItemWorker)
}


// ---------------------------------------------------------------------------------------------------------------------
// Saga add data item
export function* dCategoriesAddItemWorker(actionObject: {
    type: string,
    payload: {
        filters: typeCategoriesFilters,
        paginationRequest: typeRequestPagination
    }
}) {

    yield put(dashboardLoaderAC(true))


    yield notificationCreator('SUCCESS_ADD_ITEM')
    yield getData({
                      filters: actionObject.payload.filters,
                      paginationRequest: actionObject.payload.paginationRequest
                  })

    yield put(dashboardLoaderAC(false))

}

export function* dCategoriesAddDataWatcher() {
    yield takeLatest(dCategoriesAddItemSagaAC.type, dCategoriesAddItemWorker)
}


// ---------------------------------------------------------------------------------------------------------------------
// Saga delete data item  , have taken api for bulk for 1 item in array
export function* dCategoriesDeleteItemWorker(actionObject: {
    type: string,
    payload: {
        itemId: string,
        filters: typeCategoriesFilters,
        paginationRequest: typeRequestPagination
    }
}) {
    yield put(dashboardLoaderAC(true))

    let response = yield call(deleteCategoriesBulk, { bulkIds: [ actionObject.payload.itemId ] })

    if (response.status === 200) {
        yield notificationCreator('SUCCESS_DELETE_ITEM')
        yield getData({
                          filters: actionObject.payload.filters,
                          paginationRequest: actionObject.payload.paginationRequest
                      })
    } else {
        yield errorGenerator(response)
    }
    yield put(dashboardLoaderAC(false))
}

export function* dCategoriesDeleteDataWatcher() {
    yield takeLatest(dCategoriesDeleteItemSagaAC.type, dCategoriesDeleteItemWorker)
}

// ---------------------------------------------------------------------------------------------------------------------

// Saga delete bulk data
export function* dCategoriesDeleteBulkWorker(actionObject: {
    type: string,
    payload: {
        bulkIds: string[],
        filters: typeCategoriesFilters,
        paginationRequest: typeRequestPagination
    }
}) {

    yield put(dashboardLoaderAC(true))

    let response = yield call(deleteCategoriesBulk, { bulkIds: actionObject.payload.bulkIds })

    if (response.status === 200) {
        yield notificationCreator('SUCCESS_BULK_DELETE')

        yield getData({
                          filters: actionObject.payload.filters,
                          paginationRequest: actionObject.payload.paginationRequest
                      })

    } else {
        yield errorGenerator(response)
    }
    yield put(dashboardLoaderAC(false))

}

export function* dCategoriesBulkDeleteWatcher() {
    yield takeLatest(dCategoriesBulkDeleteSagaAC.type, dCategoriesDeleteBulkWorker)
}

// ---------------------------------------------------------------------------------------------------------------------

// Saga recover bulk data
export function* dCategoriesRecoverBulkWorker(actionObject: {
    type: string,
    payload: {
        bulkIds: string[],
        filters: typeCategoriesFilters,
        paginationRequest: typeRequestPagination
    }
}) {
    yield put(dashboardLoaderAC(true))

    let response = yield call(bulkRecoverCategory, { bulkIds: actionObject.payload.bulkIds })


    if (response.status === 200) {
        yield notificationCreator('SUCCESS_RECOVER_ITEM')

        yield getData({
                          filters: actionObject.payload.filters,
                          paginationRequest: actionObject.payload.paginationRequest
                      })

    } else {
        yield errorGenerator(response)
    }
    yield put(dashboardLoaderAC(false))

}

export function* dCategoriesBulkRecoverWatcher() {
    yield takeLatest(dCategoriesRecoverBulkSagaAC.type, dCategoriesRecoverBulkWorker)
}
